import React, { Fragment, useState } from 'react'
import { Col, Container, Row, Form } from 'react-bootstrap'
import { SearchIcon } from '../Components/Icon/Icon';
import ModalComingSoon from '../Components/Modal/ModalComingSoon'
import { submitContactForm } from '../services/contactAPI'

const Homepage = () => {
    const [showComingSoon, setShowComingSoon] = useState(false);
    
    // Contact form state
    const [contactForm, setContactForm] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
    })
    const [isContactSubmitting, setIsContactSubmitting] = useState(false)
    const [contactSubmitted, setContactSubmitted] = useState(false)

    const handleClose = () => setShowComingSoon(false);
    const handleShow = () => setShowComingSoon(true);
    
    // Contact form handlers
    const handleContactChange = (e) => {
        setContactForm({
            ...contactForm,
            [e.target.name]: e.target.value
        })
    }
    
    const handleContactSubmit = async (e) => {
        e.preventDefault()
        setIsContactSubmitting(true)
        
        try {
            // Call the API service
            await submitContactForm(contactForm)
            
            setContactSubmitted(true)
            setContactForm({ firstName: '', lastName: '', email: '', message: '' })
        } catch (error) {
            console.error('Contact form error:', error)
            alert('Failed to send message. Please try again.')
        } finally {
            setIsContactSubmitting(false)
        }
    }
    return (
        <Fragment>

            <ModalComingSoon show={showComingSoon} handleClose={() => handleClose()} />

            {/* start:hero */}
            <section id="home" className='relative overflow-hidden min-h-screen pt-[88px] lg:pt-[98px] -mt-[88px] lg:-mt-[98px] bg-MsoftYellow flex flex-wrap pb-0'>
                <img src="./assets/images/001.svg" className='absolute left-0 top-0 w-full h-full object-cover' alt="" />
                <Container className='relative z-[2] w-full pt-[80px] relative'>
                    <Row className='justify-center relative z-2'>
                        <Col md={8} className='text-center' >
                            <div className="mb-10">
                                <h1 className='font-medium text__64 text-Mblack mb-3'>
                                    Real Homemade Food from Your Community
                                </h1>
                                <p className='leading-[30px] text__18'>Connect with local home cooks and discover authentic, handmade dishes <br className='lg:block hidden' /> made with love in kitchens near you.</p>
                            </div>


                            <div className="mx-auto max-w-[566px] flex items-center pl-[16px] pr-[4px] py-[4px] rounded-full bg-white border border-solid !border-white gap-2">
                                <div className="flex-shrink-0">
                                    <SearchIcon color={"#A3A3A3"} />
                                </div>
                                <input type="text" id="address-search" name="address" autoComplete="address-line1" className="w-full bg-transparent outline-none shadow-none text__14 placeholder:text-[#A3A3A3]" placeholder="Enter address ..." disabled />
                                <div onClick={handleShow} className="inline-block cursor-pointer text-center font-semibold text__14 text-white bg-Morange !py-[10px] sm:!py-[15px] !px-[20px] sm:!px-[28px] !border-Morange btnClass flex-shrink-0 hover:bg-[#E66B00]">Find Now</div>
                            </div>
                            
                            {/* Gap between search bar and hero image */}
                            <div className="py-8"></div>
                        </Col>
                    </Row>
                </Container>
                <img src="./assets/pantria/hero-nanny.png" className='w-full object-cover relative z-[2]' alt="" />
            </section>
            
            <section className='bg-Myellow'>
                <Container>
                    <Row className='justify-center gap-y-6'>
                        <Col md={6} lg={4}>
                            <div className="p-[1.5rem] rounded-[24px] bg-white border border-1 !border-white h-full">
                                <div className="flex gap-[12px] flex-wrap sm:flex-nowrap gap-y-6">
                                    <div className="flex-shrink-0 flex items-center justify-center">
                                        <img src="./assets/images/tp (3).svg" className='w-[32px] sm:w-auto' alt="" />
                                    </div>
                                    <div className="w-full">
                                        <h5 className='font-medium text__20 text-Mblack mb-2'>Real Homemade Food, Made with Love</h5>
                                        <p className='text__16 text-Mblack'>Skip the mass-produced meals. On Pantria, every dish comes from local home cooks and small kitchens—where recipes are passed down, not factory-made.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6} lg={4}>
                            <div className="p-[1.5rem] rounded-[24px] bg-white border border-1 !border-white h-full">
                                <div className="flex gap-[12px] flex-wrap sm:flex-nowrap gap-y-6">
                                    <div className="flex-shrink-0 flex items-center justify-center">
                                        <img src="./assets/images/tp (1).svg" className='w-[32px] sm:w-auto' alt="" />
                                    </div>
                                    <div className="w-full">
                                        <h5 className='font-medium text__20 text-Mblack mb-2'>Support Your Community</h5>
                                        <p className='text__16 text-Mblack'>When you buy on Pantria, you're supporting neighbours, not chains. Turn their pantry into your next delicious discovery.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col md={6} lg={4}>
                            <div className="p-[1.5rem] rounded-[24px] bg-white border border-1 !border-white h-full">
                                <div className="flex gap-[12px] flex-wrap sm:flex-nowrap gap-y-6">
                                    <div className="flex-shrink-0 flex items-center justify-center">
                                        <img src="./assets/images/tp (2).svg" className='w-[32px] sm:w-auto' alt="" />
                                    </div>
                                    <div className="w-full">
                                        <h5 className='font-medium text__20 text-Mblack mb-2'>Food with a Story</h5>
                                        <p className='text__16 text-Mblack'>Meet the people behind your food. From grandma's secret brownies to a student's side-hustle samosas—every bite has a backstory.</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {/* end:hero */}

            {/* About Section */}
            <section id="about" className='relative overflow-hidden bg-MsoftYellow flex flex-wrap pb-0'>
                <img src="./assets/images/001.svg" className='absolute left-0 top-0 w-full h-full object-cover' alt="" />
                <Container className='relative z-[2] w-full pt-[80px] pb-[80px] relative'>
                    <img src="./../images/Burst-circle-1.png" className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2' alt="" />
                    <Row className='justify-center relative z-2'>
                        <Col md={10} className='text-center' >
                            <h5 className='font-medium text__18 text-Myellow mb-3'>ABOUT US</h5>
                            <h1 className='font-medium text__64 text-Mblack mb-3 relative'>
                                <img src="./assets/images/Vector (1).png" className='absolute w-[50px] lg:w-auto right-0 md:-right-[4rem] -top-[4.5rem]' alt="" />
                                <span className="relative">
                                    <img src="./assets/images/Vector.png" className='absolute -left-[3.5rem] -top-[2.5rem] w-[50px] lg:w-auto' alt="" />
                                    <span className='relative z-2'>Where</span>
                                </span> passion for homemade food meets community connection!
                            </h1>
                            <p className='leading-[30px] text__18'>At Pantria, we believe food tastes better when it's made by hand, not machine<br />—and even better when shared.</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='bg-white lg:pb-[80px] pb-0 mx-[16px] rounded-tl-[40px] rounded-tr-[40px]'>
                <Container>
                    <Row className='gap-y-6'>
                        <Col md={6} className='my-auto'>
                            <img src="./assets/pantria/community_sample.png" alt="" />
                        </Col>
                        <Col md={6} className='my-auto'>
                            <h2 className='font-medium text__48 mb-3'>Our Mission</h2>
                            <p className='text__18 mb-3'>Born from a passion for real, homemade flavours, we're on a mission to connect food lovers and home cooks across the UK. Whether you're a baker with a secret-recipe sourdough, a busy parent selling hearty meals, or simply someone who craves food made the old-fashioned way, Pantria is your table.</p>
                            <p className='text__18'>We celebrate the stories behind every dish—the late-night jam sessions, the passed-down family recipes, the "I just winged it" triumphs.</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='bg-white mx-[16px] rounded-bl-[40px] rounded-br-[40px]'>
                <Container>
                    <Row className='gap-y-6'>
                        <Col md={6} className='my-auto md:!order-1 order-2'>
                            <h2 className='font-medium text__48 mb-3'>Our Promise</h2>
                            <p className='text__18 mb-3'>Because great food isn't just about ingredients; it's about connection. Here, pantries become businesses, neighbours become suppliers, and every bite comes with a backstory.</p>
                            <p className='text__18'>Join us. Trade generously, eat intentionally, and keep homemade alive.</p>
                        </Col>
                        <Col md={6} className='my-auto order-1 md:!order-2'>
                            <img src="./assets/pantria/pantry_sample.png" alt="" />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Section */}
            <section id="contact" className='bg-[#F8F8F8] py-[80px]'>
                <Container>
                    <div className="p-6 bg-white rounded-[24px]">
                        <Row className='justify-between'>
                            <Col className='mb-4 md:mb-0' md={4}>
                                <h2 className='font-medium text__48 mb-3'>We'd love to hear from you.</h2>
                                <p className='text__18 text-[#525252]'>Ready to start your homemade food journey? Have questions about joining our community? We're here to help.</p>

                                <div className="my-8">
                                    <p className='text__14 mb-2'>Get in touch:</p>
                                    <h5 className='font-medium text__20 text-Myellow'>hello@pantria.co</h5>
                                </div>

                                <p className='text__14 mb-2'>Follow Us</p>
                                <div className="flex items-center gap-2">
                                    <a href="https://instagram.com/pantria.co" target="_blank" rel="noopener noreferrer">
                                        <img src="./assets/images/sos (3).svg" alt="Instagram" />
                                    </a>
                                    <a href="https://facebook.com/pantria" target="_blank" rel="noopener noreferrer">
                                        <img src="./assets/images/sos (4).svg" alt="Facebook" />
                                    </a>
                                </div>
                            </Col>
                            <Col md={7}>
                                {contactSubmitted ? (
                                    <div className="text-center py-8">
                                        <div className="w-16 h-16 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-4">
                                            <span className="text-2xl text-green-600">✓</span>
                                        </div>
                                        <h4 className="text__20 font-medium text-Mblack mb-2">Message sent!</h4>
                                        <p className="text__16 text-[#525252]">Thank you for contacting us. We'll get back to you soon.</p>
                                        <button 
                                            onClick={() => setContactSubmitted(false)}
                                            className="mt-4 text__14 text-Morange hover:text-[#E66B00] cursor-pointer"
                                        >
                                            Send another message
                                        </button>
                                    </div>
                                ) : (
                                    <form onSubmit={handleContactSubmit}>
                                        <Row>
                                            <Col className='col-6'>
                                                <Form.Group className="mb-3" controlId="firstName">
                                                    <Form.Label className='font-normal text__14 text-[#A3A3A3]'>First Name<span className='text-[#ED544E]'>*</span></Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="firstName"
                                                        placeholder="First Name" 
                                                        value={contactForm.firstName}
                                                        onChange={handleContactChange}
                                                        required
                                                        disabled={isContactSubmitting}
                                                        className='font-medium text__14 bg-[#FAFAFA] h-[54px] rounded-[20px] px-3 outline-none shadow-none focus:outline-none focus:shadow-none border-[#F5F5F5] focus:border-[#F5F5F5] focus:bg-[#FAFAFA]' 
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-6'>
                                                <Form.Group className="mb-3" controlId="lastName">
                                                    <Form.Label className='font-normal text__14 text-[#A3A3A3]'>Last Name<span className='text-[#ED544E]'>*</span></Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="lastName"
                                                        placeholder="Last Name" 
                                                        value={contactForm.lastName}
                                                        onChange={handleContactChange}
                                                        required
                                                        disabled={isContactSubmitting}
                                                        className='font-medium text__14 bg-[#FAFAFA] h-[54px] rounded-[20px] px-3 outline-none shadow-none focus:outline-none focus:shadow-none border-[#F5F5F5] focus:border-[#F5F5F5] focus:bg-[#FAFAFA]' 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Form.Group className="mb-3" controlId="email">
                                            <Form.Label className='font-normal text__14 text-[#A3A3A3]'>Email<span className='text-[#ED544E]'>*</span></Form.Label>
                                            <Form.Control 
                                                type="email" 
                                                name="email"
                                                autoComplete="email"
                                                placeholder="Email address" 
                                                value={contactForm.email}
                                                onChange={handleContactChange}
                                                required
                                                disabled={isContactSubmitting}
                                                className='font-medium text__14 bg-[#FAFAFA] h-[54px] rounded-[20px] px-3 outline-none shadow-none focus:outline-none focus:shadow-none border-[#F5F5F5] focus:border-[#F5F5F5] focus:bg-[#FAFAFA]' 
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="message">
                                            <Form.Label className='font-normal text__14 text-[#A3A3A3]'>Your Message<span className='text-[#ED544E]'>*</span></Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name="message"
                                                placeholder="How can we help?"
                                                value={contactForm.message}
                                                onChange={handleContactChange}
                                                required
                                                disabled={isContactSubmitting}
                                                style={{ height: '100px' }}
                                                className='font-medium text__14 bg-[#FAFAFA] rounded-[20px] py-3 px-3 outline-none shadow-none focus:outline-none focus:shadow-none border-[#F5F5F5] focus:border-[#F5F5F5] focus:bg-[#FAFAFA]'
                                            />
                                        </Form.Group>

                                        <button 
                                            type="submit"
                                            disabled={isContactSubmitting}
                                            className='inline-block cursor-pointer text-center font-medium text__16 text-white !py-[15px] !px-[28px] bg-Morange !border-Morange btnClass hover:bg-[#E66B00] disabled:opacity-50 disabled:cursor-not-allowed'
                                        >
                                            {isContactSubmitting ? 'Sending...' : 'Submit'}
                                        </button>
                                    </form>
                                )}

                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>

            {/* <SecGetstart /> */}
        </Fragment >
    )
}

export default Homepage
